import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, [
    'status',
    'index',
    'locationIndex',
    'autoCreateLegalEntities',
    'autoCreateBusinessUnits',
    'type',
  ]);
  const createDivision = `createDivision(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createDivision} {
      id
    }
  }
`;
};
